module.exports = __webpack_public_path__ + "7ccebb49554a78d2e80a13156783ff46.pdf";